import { Component, Input, OnInit } from '@angular/core';
import { CertificationType, RealProperty } from '@eemo/api-client';
import { DeviceDetectorService } from 'ngx-device-detector';

import { TooltipDirective } from '@/directives/tooltip/tooltip.directive';
import { DatePipe, NgClass, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

export type BadgeSize = 'NORMAL' | 'SMALL';

export const BadgeSize = {
  NORMAL: 'NORMAL' as BadgeSize,
  SMALL: 'SMALL' as BadgeSize
};

@Component({
  selector: 'app-certification-badge',
  templateUrl: './certification-badge.component.html',
  styleUrls: ['./certification-badge.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, MatIconModule, DatePipe, TooltipDirective]
})
export class CertificationBadgeComponent implements OnInit {
  @Input() prop: RealProperty;
  @Input() size: BadgeSize;
  @Input() widthDate = false;

  tooltip: string;
  icon: string;
  certifClass = 'certif-stamp';
  certificationTypeLabel = '';
  constructor(private deviceService: DeviceDetectorService) {}

  ngOnInit() {
    this.certificationTypeLabel = CertificationType.PROFESSIONAL === this.prop.certificationType ? '(Pro)' : '';
    if (this.size === BadgeSize.SMALL || this.deviceService.isMobile()) {
      this.certifClass += ' certif-small';
    }
    if (this.prop.archived) {
      this.tooltip = 'Bien archivé';
      this.icon = 'inventory';
      this.widthDate = false;
    } else {
      this.tooltip = ``;
      this.icon = 'verified';
    }
  }
}
